// extracted by mini-css-extract-plugin
export default {"dropZoneArea":"dropZoneArea__MwEnD","whiteBackground":"whiteBackground__EFJV3","horizontalDropZoneArea":"horizontalDropZoneArea__pq3BW","posAbsolute":"posAbsolute__hzfs8"};